import React from 'react';
import { useTranslation } from 'react-i18next';

const TrajectoryStatsWidget = ({ trajectoryStats, formatDate }) => {
    const { t } = useTranslation();
    if (!trajectoryStats) return null;
    return (
        <div>
            <h3 className="text-lg font-medium text-ink mb-3">{t('userDashboard.academicTrajectory')}</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-surface-muted border border-edge p-4 rounded-lg">
                    <p className="text-sm text-ink-subtle">{t('userDashboard.totalEvents')}</p>
                    <p className="text-lg font-semibold text-ink">{trajectoryStats.events}</p>
                </div>
                <div className="bg-surface-muted border border-edge p-4 rounded-lg">
                    <p className="text-sm text-ink-subtle">{t('userDashboard.totalConnections')}</p>
                    <p className="text-lg font-semibold text-ink">{trajectoryStats.connections}</p>
                </div>
                <div className="bg-surface-muted border border-edge p-4 rounded-lg">
                    <p className="text-sm text-ink-subtle">{t('userDashboard.lastAnalysis')}</p>
                    <p className="text-lg font-semibold text-ink">{formatDate(trajectoryStats.lastAnalysis)}</p>
                </div>
            </div>
        </div>
    );
};

export default TrajectoryStatsWidget; 